/**
 * @fileoverview DiagramSpec — single source of truth for agent-authored
 * Mermaid diagrams.
 *
 * Used by the createDiagram tool (as its inputSchema), the inline chat
 * DiagramCard, and the canvas DiagramNode. One definition, imported on both
 * backend and frontend (depends only on zod so it is safe to bundle in the
 * browser). The Mermaid source itself is validated client-side at render
 * time — invalid syntax degrades to an error card with the raw source.
 */
import { z } from "zod";

export const DiagramSpecSchema = z.object({
  title: z.string().min(1),
  description: z.string().optional(),
  /**
   * Mermaid source, e.g. "flowchart TD\n  A[Start] --> B[End]". Any diagram
   * type Mermaid supports: flowchart, sequenceDiagram, classDiagram,
   * stateDiagram-v2, erDiagram, gantt, pie, mindmap, timeline.
   */
  code: z.string().min(1),
});

export type DiagramSpec = z.infer<typeof DiagramSpecSchema>;
